<template>
    <div class="fj-details">
        <el-dialog
            title="详情"
            :visible.sync="show"
            width="1200px"
            :before-close="handleClose">
            <div  >
                <el-form class="info-form" v-if='rowInfo' :label-width="labelWidth">  
                    <el-form-item v-if="rowInfo.title" label="名称："  >
                        <div v-html="rowInfo.title"> </div>
                    </el-form-item>
                    <el-form-item v-if="rowInfo.ywzc" label="组成：" >
                        <div v-html="rowInfo.ywzc"> </div>
                    </el-form-item>
                    <el-form-item v-if="rowInfo.gx" label="功效：" >
                        <div v-html="rowInfo.gx"> </div>
                    </el-form-item>
                    <el-form-item v-if="rowInfo.zz" label="主治：" >
                        <div v-html="rowInfo.zz"> </div>
                    </el-form-item>
                    <el-form-item v-if="rowInfo.yf" label="用法：" >
                        <div v-html="rowInfo.yf"> </div>
                    </el-form-item>
                    <el-form-item v-if="rowInfo.jj" label="禁忌：" >
                        <div v-html="rowInfo.jj"></div>
                    </el-form-item>
                    <el-form-item v-if="rowInfo.cc" label="处方来源：" >
                        <div v-html="rowInfo.cc"> </div>
                    </el-form-item>
                     
                </el-form>
                <!-- <div class="back-btn">
                    <el-button @click="back_btn">返回上一页</el-button>
                </div> -->
                
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button> 
            </span>
        </el-dialog> 
    </div>
</template>

<script>
import {getClassicList } from '../../../io/api.js' 
export default {
    props: ['show','rowInfo'],
    data () {
        return {
            keyWord:this.$route.query.keyWord||'',
            sourceType:this.$route.query.sourceType||'', 
            id:'',
            labelWidth:'140px',
            // rowInfo:{}, 
        }
    },
    mounted () {
        // this.getInit()  
    },
    methods: {   
        handleClose() {
            this.$emit('update:show',false)
            // this.$emit('cancel');
        },
    },
    
}
</script>
<style lang="less" scoped> 
.fj-details{
    ::v-deep .el-form-item{
        margin-bottom: 14px;
    }
    ::v-deep .el-form-item__label{
        font-weight: bold;
    }
    ::v-deep .el-form-item__label,::v-deep .el-form-item__content{
        font-size:16px
    }
}

</style>